











import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class FitButton extends Vue {
  @Prop({ default: "primary" }) public type!: string;
  @Prop({ default: "normal" }) public size!: string;
  @Prop({ default: false }) public disabled!: boolean;
  @Prop({ default: false }) public ghost!: boolean;

  public click() {
    if (this.disabled || this.type === "disabled") {
      return;
    }
    this.$emit("click");
  }
}
